import axios from "axios";
import { ref } from "vue";
import { APIS_IA, TIMEOUTTIME } from "@/constants/apis";
import { showConsoleError } from "@/functions/errors";



export async function getUserLoginToken() {

    const params = {
        "username": "admin",
        "password": "Admin2024!"
    }

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .post(APIS_IA.value.getUserLoginToken, params, { timeout: TIMEOUTTIME })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any>({})
            const showGraphs = ref(true)
            // if (finalData.length > 0) {
            finalObj.value = finalData
            // }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}



import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

export function useChat() {
    const stompClient = ref<Client | null>(null);
    const messagesChat = ref<any[]>([]);
    const isProcessing = ref(false);

    const connectAndSendMessage = (token: string, chatId: string, texto: string, equipo: { name: string, ip: string }) => {
        isProcessing.value = true;

        // 1. Si ya existe una conexión previa y está activa, la usamos
        if (stompClient.value?.connected) {
            enviar(texto, chatId, equipo);
            return;
        }

        // 2. Si no, creamos el cliente SockJS
        const client = new Client({
            webSocketFactory: () => new SockJS(APIS_IA.value.wsSmartlink),
            connectHeaders: { Authorization: `Bearer ${token}` },
            // debug: (str) => console.log('STOMP Debug:', str), // Esto ya te muestra tráfico en consola
        });

        client.onConnect = () => {
            // console.log('%c Conexión Establecida ', 'background: #222; color: #bada55');

            // 3. Suscripción dinámica
            client.subscribe(`/topic/respuestas/${chatId}`, (payload) => {
                const res = JSON.parse(payload.body);

                // MOSTRAR EN CONSOLA LO QUE RECIBIMOS
                // console.log('%c Mensaje Recibido del WS: ', 'color: #007bff; font-weight: bold;', res);

                // Agregamos al historial para la vista
                messagesChat.value.push(res);

                // 4. Si la respuesta es SUCCESS, ya obtuvimos lo que queríamos
                if (res.estado === 'SUCCESS') {
                    // console.log('%c ✅ Respuesta final alcanzada.', 'color: green; font-weight: bold;');
                    isProcessing.value = false;
                    // Aquí podrías decidir si desconectar o simplemente dejar de escuchar
                }
            });

            // 5. Enviar el mensaje apenas conecte
            stompClient.value = client;
            enviar(texto, chatId, equipo);
        };

        client.activate();
    };

    const enviar = (texto: string, chatId: string, equipo: { name: string, ip: string }) => {

        const mensaje = equipo.ip === 'N/A' ? {
            texto,
            chatId,
        } : {
            texto,
            chatId,
            equipoIp: equipo.ip,
            equipoNombre: equipo.name
        };

        stompClient.value?.publish({
            destination: '/app/chat',
            body: JSON.stringify(mensaje)
        });
        // console.log('Mensaje enviado a /app/chat:', texto);
    };

    return { messagesChat, connectAndSendMessage, isProcessing };
}